import { Route } from "react-router-dom";
import MigrationView from "../views/MigrationView";


// Rinvox's own migration board. Root only -- the page itself checks, and so does the hub.
function MigrationRoutes() {
    return (
        [
            <Route key="migration" path="/migration" element={<MigrationView />} />
        ]
    );
}

export default MigrationRoutes;
